import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss']
})
export class DateRangePickerComponent {
  calendar = inject(NgbCalendar);
  formatter = inject(NgbDateParserFormatter);

  hoveredDate: NgbDate | null = null;
  fromDateStr = '';
  toDateStr = '';

  @Input('fromDate') fromDate: NgbDate | null = null;
  @Input('toDate') toDate: NgbDate | null = null;

  @Output() toDateChange: EventEmitter<string> = new EventEmitter<string>(); // Page size change event
  @Output() fromDateChange: EventEmitter<string> = new EventEmitter<string>(); // Page size change event
  @Input('maxDate') MaxDate: NgbDateStruct | null = null;
  @Input('minDate') MinDate: NgbDateStruct | null = null;

  constructor() {}

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      let toStr = `${date.year}-${date.month}-${date.day}`;
      this.toDateChange.emit(toStr);
    } else {
      this.toDate = null;
      this.fromDate = date;
      let fromStr = `${date.year}-${date.month}-${date.day}`;
      this.fromDateChange.emit(fromStr);
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
}
